<div class="progress-pie-chart" #ppc>
  <div class="additional-border"></div>
  <div class="ppc-progress">
    <div class="ppc-progress-fill" #ppcFill></div>
  </div>
  <div class="ppc-percents">
    <div class="pcc-percents-wrapper">
      <span>{{value}}</span>
    </div>
  </div>
</div>
<p class="description">{{description}}</p>
